import $ from 'jquery';
import StarRating from 'vue-star-rating';
import VueMask from 'v-mask'
import Store from './components/store';
import Vuex from "vuex";

window.Vue = require('./../vue2.js');
// window._ = require('lodash');
window.axios = require('axios');

window.$ = window.jQuery = require('jquery/dist/jquery');

Vue.use(VueMask);

// require('../sentry.js');
Vue.component('star-rating', StarRating);

Vue.component('show-product', () => import('./components/ShowProduct.vue'));
Vue.component('show-bundle', () => import('./components/ShowBundle.vue'));
Vue.component('list-products', require('./components/ListProducts.vue'));
Vue.component('list-bundles', require('./components/ListBundles.vue'));
Vue.component('list-promotions', require('./components/ListPromotions.vue'));
Vue.component('evaluations', () => import('./components/Evaluations.vue'));
Vue.component('carousel', () => import('./components/Carousel.vue'));
Vue.component('license', () => import('./components/License.vue'));
Vue.component('show-license', () => import('./components/ShowLicense.vue'));
Vue.component('zoom-image-modal', () => import('@/components/ZoomImageModal.vue'));

Vue.component('horizontal-pagination', require('./components/HorizontalPagination.vue'));
Vue.component('data-list-component', require('./components/DataListComponent.vue'));
Vue.component('horizontal-data-list-component', require('./components/HorizontalDataList.vue'));

Vue.component('loader', require('../components/Loader.vue'));
Vue.component('table-items', require('./components/TableItems.vue'));
Vue.component('freight-template', require('./components/Freight.vue'));
Vue.component('table-order', require('./components/TableOrder.vue'));

Vue.component('parcels', require('./components/Parcels.vue'));

Vue.component('total-payment', require('./components/TotalPayment.vue'));

Vue.component('simulator-form', require('./components/Simulator.vue'));

Vue.component('contact', () => import('./components/Contact.vue'));
Vue.component('modal-politics-and-privacy', () => import('./components/ModalPoliticsAndProvacy.vue'));

Vue.component('title-divider', require('@/components/TitleDivider.vue'));
Vue.component('has-error', () => import('@/components/HasError.vue'));

Vue.component('freight-address', () => import('./components/FreightAddress.vue'));

//Form Payments
Vue.component('method-payment', () => import('./components/payment/MethodPayment.vue'));
Vue.component('form-payment', () => import('./components/payment/FormPayment.vue'));
Vue.component('payment-slip', () => import('./components/payment/PaymentSlip.vue'));
Vue.component('payment-paypal', () => import('./components/payment/PaymentPaypal.vue'));
Vue.component('payment-credit-card', () => import('./components/payment/PaymentCreditCard.vue'));
Vue.component('email-contact', () => import('./components/payment/EmailContact.vue'));

const store = new Vuex.Store(Store);

const app = new Vue({
  el: '#app',
  store,

  methods: {
    gritter(title, text, className, time = 8000) {
      $.gritter.add({
        title: title,
        text: text,
        class_name: 'color ' + className,
        time: time
      });
    },
  },
});



// WEBPACK FOOTER //
// ./resources/assets/js/store/app.js